import React from "react";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { local } from "../../internationalization/Localization";
import "./SelectionUI.scss";

export interface SelectionUIItem {
  title: string
  value: com.ts.mobile.sdk.AuthenticatorSelectionResult | com.ts.mobile.sdk.ControlRequest
}

export interface SelectionUIProps {
  items: SelectionUIItem[];
  instructions: string;
  cancelRequest?: com.ts.mobile.sdk.AuthenticatorSelectionResult ;
  resolve: (value: any | PromiseLike<any>) => void;
}

export const SelectionUI: React.FunctionComponent<SelectionUIProps> = (props) => {

  const onButtonClick = (event: React.MouseEvent<HTMLButtonElement>, item: SelectionUIItem) => {
    event.preventDefault();
    props.resolve(item.value);
  }
  const onCancelButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    props.cancelRequest && props.resolve(props.cancelRequest);
  }

  const buttonGroups = props.items.map((item, index) => (
    <div key={index} className="App_formButtonGroup">
      {props.cancelRequest &&
        <Button
          variant={ButtonVariant.secondary}
          onClick={onCancelButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
          {local.get("buttonLabels[0]")}
        </Button>
      }
      <Button
        variant={ButtonVariant.primary}
        onClick={(e) => onButtonClick(e, item)}
        theme={MITheme.dark}
        size={ButtonSize.large}
      >
        {item.title}
      </Button>
    </div>
  ))

  return (
    <div className="SelectionUI">
      <p>{props.instructions}</p>
      {buttonGroups}
    </div>
  )
}
